import React from 'react';
import '../styles/theme.css';

export default function Footer() {
  return (
    <footer className="footer">
      <span>Mathursan Balathas · {new Date().getFullYear()}</span>
      {/* <span>Built clean. Deployed fast.</span> */}
    </footer>
  );
}
